export const isAscending = (pin: string): boolean => {
    return '0123456789'.includes(pin);
};

export const isDescending = (pin: string): boolean => {
    return '9876543210'.includes(pin);
};

export const isRepeating = (pin: string): boolean => {
    return /^(\d)\1{5}$/.test(pin);
};

export const isValidPin = (pin: string) => {
    return !isDescending(pin) && !isRepeating(pin) && !isAscending(pin);
};
